export const GAME_VERSION = '1.5.37';